import { ActionIcon, Avatar, Loader, Tooltip } from '@mantine/core'

import IconCheckmarkCircle from 'src/icons/IconCheckmarkCircle'
import IconClose from 'src/icons/IconClose'
import IconCloseCircle from 'src/icons/IconCloseCircle'
import { getInitials } from 'src/lib/formatters'

const ApplicantList = ({
  applicants,
  bulkSmsLoading,
  bulkSmsResult,
  setApplicants,
}) => {

  const removeApplicant = (applicantId) => {
    setApplicants(
      applicants.filter((applicant) => applicant.applicantId !== applicantId)
    )
  }

  const renderApplicantIcon = (applicant) => {
    if (bulkSmsLoading) {
      return <Loader size={'xs'} color="gray" />
    } else if (bulkSmsResult) {
      const result = bulkSmsResult.find(
        (result) => result.applicantId === applicant.applicantId
      )
      if (result?.success) {
        return (
          <IconCheckmarkCircle className="h-3 fill-none stroke-doubleNickel-success-500" />
        )
      } else {
        return (
          <Tooltip label={result.errorMsg}>
            <div>
              <IconCloseCircle className="h-3 fill-none stroke-doubleNickel-error-500" />
            </div>
          </Tooltip>
        )
      }
    }
  }

  return (
    <div className="rounded-lg border border-doubleNickel-gray-200 bg-white">
      <div className="max-h-[250px] overflow-auto">
        {applicants.map((applicant, index) => (
          <div
            key={applicant.applicantId}
            className={[
              'flex items-center justify-between gap-3 px-3 py-1 text-xs',
              index === applicants.length - 1
                ? ''
                : 'border-b border-doubleNickel-gray-200',
            ].join(' ')}
          >
            <div className="flex min-w-0 items-center gap-3">
              <Avatar
                classNames={{
                  placeholder:
                    'bg-doubleNickel-brand-25 text-doubleNickel-brand-500',
                }}
                size="sm"
                radius="sm"
              >
                {getInitials(applicant.name)}
              </Avatar>
              <div className="truncate font-medium text-doubleNickel-gray-900">
                {applicant.name}
              </div>
            </div>

            <div className="flex shrink-0 items-center gap-2">
              {renderApplicantIcon(applicant)}
              <ActionIcon
                variant="subtle"
                color="gray"
                disabled={bulkSmsLoading}
                onClick={() => {
                  if (bulkSmsLoading) return
                  removeApplicant(applicant.applicantId)
                }}
                aria-label="Remove applicant"
              >
                <IconClose className="fill-none stroke-doubleNickel-gray-500" />
              </ActionIcon>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ApplicantList
